import Immutable from 'immutable';
import {
    UPDATE_ACCESS_VERSION_CHOICE,
    UPDATE_PARENTAL_LOCK_CONFIRMED,
    UPDATE_VIDEO_STATE_NEXT_VIDEO_IS_BINGE,
} from '../actions/videoPage';

const VP = 'videoPage';
const STATE = 'state';
const PARENTAL_LOCK_CONFIRMED = 'parentalLockConfirmed';
const NEXT_VIDEO_IS_BINGE = 'nextVideoIsBinge';
const ACCESS_VERSION_CHOICE = 'accessVersionChoice';

const initialState = Immutable.fromJS({
    nextVideoIsBinge: {},
});

export default function videoPage(state = initialState, action = '') {
    switch (action.type) {
        case UPDATE_VIDEO_STATE_NEXT_VIDEO_IS_BINGE:
            return state.setIn([STATE, NEXT_VIDEO_IS_BINGE], Immutable.fromJS(action.payload));
        case UPDATE_PARENTAL_LOCK_CONFIRMED:
            return state.setIn([STATE, PARENTAL_LOCK_CONFIRMED], Immutable.fromJS(action.payload));
        case UPDATE_ACCESS_VERSION_CHOICE:
            return state.setIn([ACCESS_VERSION_CHOICE], Immutable.fromJS(action.payload));
        default:
            return state;
    }
}

export function filterMessages(messages) {
    const validMessages = [];

    messages.forEach((msg) => {
        if (msg && (msg.message || msg.link)) {
            validMessages.push({
                message: msg.message,
                link: msg.link || null,
                linkText: msg.link ? msg.linkText : null,
            });
        }
    });

    return validMessages;
}
export const nextVideoIsBingeSelector = (state) =>
    state.getIn([VP, STATE, NEXT_VIDEO_IS_BINGE], Immutable.Map());
export const parentalLockConfirmedSelector = (state) =>
    state.getIn([VP, STATE, PARENTAL_LOCK_CONFIRMED], false);
export const accessVersionChoiceSelector = (state) => state.getIn([VP, ACCESS_VERSION_CHOICE]);
